import { isToday } from 'date-fns/esm'
import { isEmpty } from 'ramda'
import { useMemo } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'

import { ContentPageLayout } from '@/layout/components/content-page-layout/ContentPageLayout'
import { AnimatedLoader } from '@/modules/shared/components/loader/Loader'
import { mapAppointmentsToTimeline, mapEncountersToTimeline } from '../../components/timeline/helpers/mapping'
import { EmptyCard } from './empty-day/EmptyCard'
import { StContainer } from './TimelineToday.styled'

import type { TimelineActivity } from '../../components/timeline/Timeline'
import type { TimelineContextType } from '../../types/timeline-context.type'

const TimelineTodayPage = ({ appointments, encounters, isLoading }: TimelineContextType) => {
  const navigate = useNavigate()

  // Template variables
  // ------------------------------------------------------------------------- /
  const activities = useMemo<TimelineActivity[]>(() => {
    return [
      ...mapAppointmentsToTimeline(appointments.value, navigate),
      ...mapEncountersToTimeline(encounters.value, navigate),
    ]
  }, [appointments.value, encounters.value, navigate])

  const firstActivityOfToday = useMemo(
    () => activities.find((activity) => isToday(new Date(activity.start))),
    [activities],
  )

  const hasActivities = useMemo(() => {
    return !isLoading && !isEmpty(activities)
  }, [activities, isLoading])

  return (
    <ContentPageLayout noScroll>
      <StContainer>
        {isLoading ? (
          <AnimatedLoader />
        ) : hasActivities ? (
          firstActivityOfToday ? (
            firstActivityOfToday?.type === 'Appointment' ? (
              <Navigate to={`/timeline/appointment/${firstActivityOfToday.id}`} />
            ) : firstActivityOfToday?.type === 'Intake' ? (
              <Navigate to={`/timeline/encounter/${firstActivityOfToday.id}`} />
            ) : (
              <Navigate to={`/timeline/activity/${firstActivityOfToday.id}`} />
            )
          ) : (
            <EmptyCard />
          )
        ) : null}
      </StContainer>
    </ContentPageLayout>
  )
}

export { TimelineTodayPage }
